/**
 * @generated SignedSource<<0f61ee5f8bd0e7bdbba7a808cb1ede49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeInput = {
  child: string;
  code?: string | null | undefined;
  description?: string | null | undefined;
  id?: string | null | undefined;
  link_id?: string | null | undefined;
  name: string;
  parent?: string | null | undefined;
  type: string;
};
export type UpdateListItemMutation$variables = {
  input: ListItemTypeInput;
};
export type UpdateListItemMutation$data = {
  readonly updateListItem: {
    readonly id: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ItemFragment">;
  } | null | undefined;
};
export type UpdateListItemMutation = {
  response: UpdateListItemMutation$data;
  variables: UpdateListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ListItem",
        "kind": "LinkedField",
        "name": "updateListItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ItemFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ListItem",
        "kind": "LinkedField",
        "name": "updateListItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "child",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d536cfbed5272e9012e86093f728e6ba",
    "id": null,
    "metadata": {},
    "name": "UpdateListItemMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateListItemMutation(\n  $input: ListItemTypeInput!\n) {\n  updateListItem(input: $input) {\n    id\n    ...ItemFragment\n  }\n}\n\nfragment ItemFragment on ListItem {\n  id\n  name\n  code\n  description\n  child\n  type\n  parent\n  link_id\n}\n"
  }
};
})();

(node as any).hash = "88dbd293c9a4a2a10789d3fcbeb60913";

export default node;
